import { render, staticRenderFns } from "./questionInStore.vue?vue&type=template&id=05a7c0f0&"
import script from "./questionInStore.vue?vue&type=script&lang=js&"
export * from "./questionInStore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports